module.exports = __webpack_public_path__ + "img/fanzhuan.9e904ad3.png";